export type EditableOverrides = {
  weatherResistance: number
  saturationModifier: number
  dryTimeModifier: number | null
}

export type EditableBaseline = EditableOverrides & {
  precipitationLookbackDays: number | null
}

// Whether the editable overrides differ from the cached production baseline. When they don't,
// running `/simulate` would recompute against *current* weather and can diverge from the cached
// production status (e.g. baseline 0.65 vs. a fresh recompute of 0.61), so callers should mirror
// the baseline rather than recompute. `lookback` is passed explicitly so the check can use a
// freshly-typed value without waiting for React state to flush. Computed precipitation fields are
// deliberately ignored: they are recompute outputs, not user intent.
export const hasEffectiveOverrides = (
  overrides: EditableOverrides,
  baseline: EditableBaseline,
  lookback: number | null,
): boolean =>
  overrides.weatherResistance !== baseline.weatherResistance ||
  overrides.saturationModifier !== baseline.saturationModifier ||
  overrides.dryTimeModifier !== baseline.dryTimeModifier ||
  lookback !== baseline.precipitationLookbackDays
